module.exports = __webpack_public_path__ + "static/ClustrMaps-2f6cfd08cedec34736d592b817f1de1b.svg";